/*
 * File: d:\projects\AutoFiFront\src\Cookies\Cookie.ts
 * Project: d:\projects\AutoFiFront
 * Created Date: Wednesday February 22nd 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Wednesday February 22nd 2023 1:40:39 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import Cookies from "universal-cookie";
import Config from "Config/Config";

const cookies = new Cookies();

/**
 * Wrapper class to handle Cookie
 */
class Cookie {
  /**
   * Set the cookie with the new data
   * @param {String} field The identifier of the cookie
   * @param {*} data The data to set
   */
  setCookie(field: string, data: any) {
    cookies.set(field, data, {
      path: "/",
      sameSite: "strict",
      expires: new Date(
        Date.now() +
          parseInt(Config.COOKIE.COOKIE_TIME_DAYS) * 24 * 60 * 60 * 1000
      ),
    });
  }

  /**
   * Get the cookie from identifier
   * @param {String} field The identifier of the cookie
   * @returns The cookie associated
   */
  getCookie(field: string) {
    return cookies.get(field);
  }

  /**
   * Removes a cookie
   * @param {String} field The identifier
   */
  removeCookie(field: string) {
    cookies.remove(field, { sameSite: "strict" });
  }
}

export default Cookie;
